import { TrackingMilestone } from '@/modules/pmt/interfaces';
import {
  TRACKING_STAGE_LIST,
  ORDERED_TRACKING_STAGE_LIST,
  CANCELLED_TRACKING_STAGE_LIST,
} from '@/modules/pmt/constants';

export const buildStageList = (currentMilestone: TrackingMilestone) => {
  switch (currentMilestone) {
    case TrackingMilestone.Ordered:
      return ORDERED_TRACKING_STAGE_LIST;
    case TrackingMilestone.Cancelled:
      return CANCELLED_TRACKING_STAGE_LIST;
    default:
      return TRACKING_STAGE_LIST;
  }
};
